export default __webpack_public_path__ + "static/media/left-scroll-icon.04a43076.svg";